import React from 'react';

import { Box, Tab, Tabs, Typography } from '@material-ui/core';

import { EmailField, emailPattern } from '@vyce/core/src/components/controlled-inputs';
import { TabCountLabel } from '@vyce/core/src/components/TabCountLabel';
import useInviteStyles from '@vyce/core/src/views/invites/styles';

import { AdminInviteDialogApi, EXISTING_USER_TAB, NEW_ADMIN_TAB } from '../../hooks/useAdminInviteDialog';
import { ExistingAdminCandidates } from './ExistingAdminCandidates';

interface Props {
  dialog: AdminInviteDialogApi;
}

export const AdminWhoStep: React.FC<Props> = ({ dialog }) => {
  const classes = useInviteStyles();
  const { tab, setTab } = dialog;

  return (
    <Box display="flex" flexDirection="column" gridGap={16}>
      <Tabs
        className={classes.tabs}
        value={tab}
        onChange={(_, value) => setTab(value)}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab
          disableRipple
          className={classes.tab}
          label={
            <TabCountLabel
              title="Invite new admin"
              count={dialog.email ? 1 : 0}
              active={tab === NEW_ADMIN_TAB}
            />
          }
        />
        <Tab
          disableRipple
          className={classes.tab}
          label={
            <TabCountLabel
              title="Existing users"
              count={dialog.pickedUser ? 1 : 0}
              active={tab === EXISTING_USER_TAB}
            />
          }
        />
      </Tabs>

      {dialog.modulesStatus === 'error' && (
        <Typography variant="body2" className={classes.errorText}>
          We couldn't load this company's roles.{' '}
          <span className={classes.more} onClick={dialog.retryModules}>
            Try again
          </span>
        </Typography>
      )}

      {/* Both panels stay mounted so the email, search and scroll survive tab switching */}
      <Box hidden={tab !== NEW_ADMIN_TAB}>
        <Typography className={classes.hint}>
          We'll email them an invite. They get access as soon as they accept it.
        </Typography>
        <EmailField margin="normal" name="email" autoFocus={false} rules={{ pattern: emailPattern }} />
      </Box>

      <Box hidden={tab !== EXISTING_USER_TAB}>
        <ExistingAdminCandidates
          companyId={dialog.companyId}
          picked={dialog.pickedUser}
          onToggle={dialog.togglePickedUser}
        />
      </Box>
    </Box>
  );
};
